import { render, staticRenderFns } from "./report-problem-modal.vue?vue&type=template&id=c1d0d0ce&scoped=true&"
import script from "./report-problem-modal.vue?vue&type=script&lang=ts&"
export * from "./report-problem-modal.vue?vue&type=script&lang=ts&"
import style0 from "./report-problem-modal.vue?vue&type=style&index=0&id=c1d0d0ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1d0d0ce",
  null
  
)

export default component.exports